import React, { useEffect, useMemo, useRef, useState } from "react";
import firebase, { storage } from "../../config/firebase";
import {
  ref,
  getDownloadURL,
  uploadBytesResumable,
  deleteObject,
} from "firebase/storage";
import { useNavigate, useParams, Link, useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import {
  Autocomplete,
  Card,
  IconButton,
  TextField,
  Alert,
  Backdrop,
  Box,
  CardContent,
  CircularProgress,
  Divider,
  FormControlLabel,
  Grid,
  InputAdornment,
  Stack,
  Switch,
  Typography,
} from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import InputMask from "react-input-mask";
import IntlCurrencyInput from "react-intl-currency-input";
import BackButton from "../../components/backButton/BackButton";
import { useSelector, useDispatch } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import ImageZoom from "../../components/imageZoom";
import Button from "@mui/material/Button";
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import AlertDialog from "../../components/dialog";
import AlertDialogCertificate from "../../components/dialog/indexCertificate";
import userService from "../../service/user.service";
import shipperService from "../../service/shipper.service";
import theme from "../../theme";
import Checkbox from '@mui/material/Checkbox';
import PercentIcon from '@mui/icons-material/Percent';
import { NumericFormat } from 'react-number-format';
import { getPaymentConditionInstallmentSummary } from "../../util/freight/freight-financial-installments";
import { GlobalSuccessModal, GlobalWarningGlobal } from "../../components/modalGlobal/modalGlobal";
import { Select } from "antd";

const STATE_UF = [
  { value: "AC", label: "Acre (AC)" },
  { value: "AL", label: "Alagoas (AL)" },
  { value: "AP", label: "Amapá (AP)" },
  { value: "AM", label: "Amazonas (AM)" },
  { value: "BA", label: "Bahia (BA)" },
  { value: "CE", label: "Ceará (CE)" },
  { value: "DF", label: "Distrito Federal (DF)" },
  { value: "ES", label: "Espírito Santo (ES)" },
  { value: "GO", label: "Goiás (GO)" },
  { value: "MA", label: "Maranhão (MA)" },
  { value: "MT", label: "Mato Grosso (MT)" },
  { value: "MS", label: "Mato Grosso do Sul (MS)" },
  { value: "MG", label: "Minas Gerais (MG)" },
  { value: "PA", label: "Pará (PA)" },
  { value: "PB", label: "Paraíba (PB)" },
  { value: "PR", label: "Paraná (PR)" },
  { value: "PE", label: "Pernambuco (PE)" },
  { value: "PI", label: "Piauí (PI)" },
  { value: "RJ", label: "Rio de Janeiro (RJ)" },
  { value: "RN", label: "Rio Grande do Norte (RN)" },
  { value: "RS", label: "Rio Grande do Sul (RS)" },
  { value: "RO", label: "Rondônia (RO)" },
  { value: "RR", label: "Roraima (RR)" },
  { value: "SC", label: "Santa Catarina (SC)" },
  { value: "SP", label: "São Paulo (SP)" },
  { value: "SE", label: "Sergipe (SE)" },
  { value: "TO", label: "Tocantins (TO)" }
]

require("firebase/auth");

function NewEmbarcador() {
  const { id } = useParams();

  let navigate = useNavigate();
  const location = useLocation();

  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const [view, setView] = useState(location.state?.viewOnly || false);

  const [socialName, setSocialName] = useState("");
  const [nameFantasy, setNameFantasy] = useState("");
  const [documentNumber, setDocumentNamber] = useState("");
  const [taxRegime, setTaxRegime] = useState("");
  const [inscricaoEstadual, setInscricaoEstadual] = useState("");

  const [phoneNumberFirst, setPhoneNumberFirst] = useState("");
  const [phoneNumberSecond, setPhoneNumberSecond] = useState("");

  const [cep, setCep] = useState("");
  const [neighborhood, setNeighborhood] = useState(""); //bairro
  const [street, setStreet] = useState(""); //endereco
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [numeroEndereco, setNumeroEndereco] = useState("");
  const [complement, setComplement] = useState("");

  const [serie, setSerie] = useState("");
  const [number, setNumber] = useState("");
  const [typeEmitente, setTypeEmitente] = useState("");
  const [typeEmissao, setTypeEmissao] = useState("Normal");
  const [responsavelSeguro, setResponsavelSeguro] = useState("Próprio");

  const [msgTipo, setMsgTipo] = useState();
  const [carregando, setCarregando] = useState(0);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState();
  const [title, setTitle] = useState();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successModalTitle, setSuccessModalTitle] = useState("");
  const [showWarningGlobal, setShowWarningGlobal] = useState(false);
  const [warningModalTitle, setWarningModalTitle] = useState("");

  const [photo, setPhoto] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null);
  const [passwordCertificate, setPasswordCertificate] = useState(null);
  const [documentCertificate, setDocumentCertificate] = useState(null);
  const [openCertificate, setOpenCertificate] = useState(false);
  const [origem, setOrigem] = useState(null);

  const [serialNumber, setSerialNumber] = useState(null);
  const [issuerName, setIssuerName] = useState(null);
  const [notValidBefore, setNotValidBefore] = useState(null);
  const [notValidAfter, setNotValidAfter] = useState(null);
  const [thumprint, setThumprint] = useState(null);
  const [subjectName, setSubjectName] = useState(null);
  const [cpfCnpj, setCpfCnpj] = useState(null);
  const [nameCompany, setNameCompany] = useState(null);

  const [documentCertificateInfo, setDocumentCertificateInfo] = useState(null);

  const [contatos, setContatos] = useState([createContatos()]);
  const [groups, setGroups] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [paymentConditions, setPaymentConditions] = useState([]);
  const [creditLimit, setCreditLimit] = useState("");
  const [selectedPaymentConditionId, setSelectedPaymentConditionId] =
    useState("");
  const [financialObservation, setFinancialObservation] = useState("");
  const [grissAdvalorem, setGrissAdvalorem] = useState("");
  const [administrationFee, setAdministrationFee] = useState("");
  const [workingCapitalFee, setWorkingCapitalFee] = useState("");
  const [otherExpenses, setOtherExpenses] = useState("");
  const [receivesIcmsBenefits, setReceivesIcmsBenefits] = useState(false);
  const [validateAllSimulations, setValidateAllSimulations] = useState(false);
  const [isTransport, setIsTransport] = useState(false);
  const [linkedExistingShipperId, setLinkedExistingShipperId] = useState(null);
  const [clientEmbarcadores, setClientEmbarcadores] = useState([]);
  const [loadingClientEmbarcadores, setLoadingClientEmbarcadores] =
    useState(false);
  /** Embarcador cliente do vínculo comercial (obrigatório se viewALL). */
  const [clientShipperForCarrierLink, setClientShipperForCarrierLink] =
    useState(null);
  const [linkEmbarcadorOptions, setLinkEmbarcadorOptions] = useState([]);
  const [loadingLinkEmbarcadores, setLoadingLinkEmbarcadores] = useState(false);
  const cnpjLookupSeqRef = useRef(0);
  const linkedFromBaseRef = useRef(null);

  const isLinkedExistingTransportadora = Boolean(linkedExistingShipperId);
  const fieldsDisabled = view || isLinkedExistingTransportadora;

  const [sellersList, setSellersList] = useState([]);
  const [seller, setSeller] = useState("");

  const selectedPaymentCondition = useMemo(
    () =>
      paymentConditions.find(
        (condition) => condition.id === selectedPaymentConditionId,
      ) || null,
    [paymentConditions, selectedPaymentConditionId],
  );

  const paymentConditionInstallmentSummary = useMemo(
    () => getPaymentConditionInstallmentSummary(selectedPaymentCondition),
    [selectedPaymentCondition],
  );
  const [paymentEmailUsersList, setPaymentEmailUsersList] = useState([]);
  const [paymentEmailUser, setPaymentEmailUser] = useState("");
  const [linkedUsers, setLinkedUsers] = useState([]);
  const [accessUserOptions, setAccessUserOptions] = useState([]);
  const [selectedAccessUserIds, setSelectedAccessUserIds] = useState([]);
  const [loadingShipperUsers, setLoadingShipperUsers] = useState(false);
  const [savingAccessUsers, setSavingAccessUsers] = useState(false);

  const userListScrollSx = {
    maxHeight: 220,
    overflowY: "auto",
    border: "1px solid rgba(1, 36, 67, 0.12)",
    borderRadius: "10px",
    backgroundColor: "#fafbfd",
    p: 1,
  };

  const userListItemSx = {
    py: 0.75,
    px: 0.5,
    borderBottom: "1px solid rgba(1, 36, 67, 0.08)",
    "&:last-child": { borderBottom: "none" },
  };

  async function loadShipperUsers(shipperId = id) {
    if (!shipperId) {
      setLinkedUsers([]);
      setAccessUserOptions([]);
      setSelectedAccessUserIds([]);
      return;
    }

    setLoadingShipperUsers(true);
    try {
      const {
        linkedUsers: linked,
        accessOptions,
        selectedAccessUserIds: selectedIds,
      } = await userService.getShipperUserManagementData(shipperId, user);
      setLinkedUsers(linked);
      setAccessUserOptions(accessOptions);
      setSelectedAccessUserIds(selectedIds);
    } catch (error) {
      console.error("Erro ao carregar usuários do embarcador:", error);
    } finally {
      setLoadingShipperUsers(false);
    }
  }

  async function handleAccessUsersChange(_event, newValue) {
    if (view || !id || savingAccessUsers) return;

    const nextSelectedUserIds = (newValue || []).map((userItem) => userItem.id);
    const previousSelectedUserIds = [...selectedAccessUserIds];

    setSelectedAccessUserIds(nextSelectedUserIds);
    setSavingAccessUsers(true);

    try {
      await userService.syncShipperAccessUsers(
        id,
        nextSelectedUserIds,
        previousSelectedUserIds,
      );
      await loadShipperUsers(id);
    } catch (error) {
      console.error("Erro ao atualizar usuários com acesso:", error);
      setSelectedAccessUserIds(previousSelectedUserIds);
      setTitle("Ops!");
      setMsg(
        error?.message ||
        "Não foi possível atualizar os usuários com acesso a este embarcador.",
      );
      setMsgTipo("erro");
      setOpen(true);
    } finally {
      setSavingAccessUsers(false);
    }
  }

  async function loadingFinancialUsers() {
    try {
      const shipperIds = userService.getShipperIdsFromUser(user);
      const [sellers, paymentUsers] = await Promise.all([
        userService.getSellersByShipperIds(shipperIds),
        userService.getUsersByShipperIds(shipperIds),
      ]);

      setSellersList(
        sellers.map((sellerUser) => ({
          value: sellerUser.id,
          label: sellerUser.name,
        })),
      );

      setPaymentEmailUsersList(
        paymentUsers.map((paymentUser) => ({
          value: paymentUser.id,
          label: paymentUser.email
            ? `${paymentUser.name} (${paymentUser.email})`
            : paymentUser.name,
        })),
      );
    } catch (error) {
      console.error("Erro ao carregar usuários financeiros:", error);
    }
  }

  const [optionsTaxRegime] = useState([
    { label: "Simples Nacional", value: "Simples Nacional" },
    { label: "Lucro Presumido", value: "Lucro Presumido" },
    { label: "Lucro Real", value: "Lucro Real" },
  ]);

  const currencyConfig = {
    locale: "pt-BR",
    formats: {
      number: {
        BRL: {
          style: "currency",
          currency: "BRL",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        },
      },
    },
  };

  const normalizeCreditLimitValue = (value) => {
    if (value === null || value === undefined || value === "") return "";
    if (typeof value === "number") return value;

    const onlyDigits = String(value)
      .replace(/\s/g, "")
      .replace("R$", "")
      .replace(/\D/g, "")
      .slice(0, 9);

    if (!onlyDigits) return "";

    return Number(onlyDigits) / 100;
  };

  function normalizeContato(contato = {}) {
    return {
      nome: contato?.nome || "",
      funcao: contato?.funcao || "",
      telefone: contato?.telefone || "",
      email: contato?.email || "",
      recebeEmail: Boolean(contato?.recebeEmail),
      receivesFinancial: Boolean(contato?.receivesFinancial),
    };
  }

  function createContatos() {
    return normalizeContato({});
  }

  const findSelectOption = (options, value) =>
    options.find(
      (option) =>
        String(option?.value || "").trim() === String(value || "").trim(),
    ) || null;

  const validateRequiredFields = () => {
    const missing = [];

    const inputEl = document.getElementById("documentNumber");
    const stateVal = documentNumber ?? "";
    const inputVal = inputEl && inputEl.value ? inputEl.value : "";
    const rawDoc =
      String(stateVal).trim() !== "" ? String(stateVal) : String(inputVal);
    const docDigits = rawDoc.replace(/\D/g, "");

    if (!docDigits || docDigits.length === 0) missing.push("CNPJ");
    if (!socialName || !String(socialName).trim()) missing.push("Razão Social");
    if (!inscricaoEstadual || !String(inscricaoEstadual).trim())
      missing.push("Inscrição Estadual");
    if (!nameFantasy || !String(nameFantasy).trim())
      missing.push("Nome Fantasia");
    if (!cep || !String(cep).trim()) missing.push("CEP");
    if (!street || !String(street).trim()) missing.push("Logradouro");
    if (!numeroEndereco || !String(numeroEndereco).trim())
      missing.push("Número");
    if (!neighborhood || !String(neighborhood).trim()) missing.push("Bairro");
    if (!city || !String(city).trim()) missing.push("Cidade");
    if (!state || !String(state).trim()) missing.push("Estado");
    // Regra do financeiro: só exige se a seção Financeiro estiver visível.
    if (!isTransport && !selectedPaymentConditionId) {
      missing.push("Condição de pagamento");
    }

    if (missing.length) {
      setTitle("Campos obrigatórios");
      setMsg("Preencha os campos: " + missing.join(", "));
      setMsgTipo("erro");
      setOpen(true);
      return false;
    }
    return true;
  };

  const handleChangeMaisContato = (index, field, value) => {
    const newContatos = [...contatos];
    newContatos[index][field] = value;
    setContatos(newContatos);
  };

  const adicionarContato = () => {
    setContatos([...contatos, createContatos()]);
  };
  const removerContato = (index) => {
    setContatos(contatos.filter((_, i) => i !== index));
  };

  const db = firebase.firestore();

  useEffect(() => {
    db.collection("tb_group")
      .get()
      .then((snapshot) => {
        const list = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
        setGroups(list);
      })
      .catch((err) => console.error("Erro carregando grupos:", err));
  }, []);

  useEffect(() => {
    const unsubscribe = db
      .collection("paymentCondition")
      .onSnapshot(
        (snapshot) => {
          const list = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
          setPaymentConditions(list);
        },
        (err) =>
          console.error("Erro carregando condicoes de pagamento:", err),
      );

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    if (!user?.uid) return;
    loadingFinancialUsers();
  }, [user?.uid, user?.uidShipper]);

  useEffect(() => {
    if (!seller || sellersList.length === 0) return;
    if (sellersList.some((option) => option.value === seller)) return;
    const matchByName = sellersList.find((option) => option.label === seller);
    if (matchByName) setSeller(matchByName.value);
  }, [sellersList, seller]);

  useEffect(() => {
    if (!paymentEmailUser || paymentEmailUsersList.length === 0) return;
    if (paymentEmailUsersList.some((option) => option.value === paymentEmailUser))
      return;
    const matchByLabel = paymentEmailUsersList.find(
      (option) => option.label === paymentEmailUser,
    );
    if (matchByLabel) setPaymentEmailUser(matchByLabel.value);
  }, [paymentEmailUsersList, paymentEmailUser]);

  useEffect(() => {
    if (!id || !user?.uid) return;
    loadShipperUsers(id);
  }, [id, user?.uid, user?.uidShipper]);

  useEffect(() => {
    let cancelled = false;

    const loadClientEmbarcadores = async () => {
      if (!id || !isTransport) {
        setClientEmbarcadores([]);
        return;
      }

      setLoadingClientEmbarcadores(true);
      try {
        const list =
          await shipperService.getClientEmbarcadoresByCarrierId(id);
        if (!cancelled) setClientEmbarcadores(list);
      } catch (error) {
        console.error("Erro ao carregar embarcadores clientes:", error);
        if (!cancelled) setClientEmbarcadores([]);
      } finally {
        if (!cancelled) setLoadingClientEmbarcadores(false);
      }
    };

    loadClientEmbarcadores();
    return () => {
      cancelled = true;
    };
  }, [id, isTransport]);

  useEffect(() => {
    let cancelled = false;

    const loadLinkEmbarcadores = async () => {
      if (!linkedExistingShipperId || user?.viewALL !== true) {
        setLinkEmbarcadorOptions([]);
        return;
      }

      setLoadingLinkEmbarcadores(true);
      try {
        const list = await shipperService.listEmbarcadoresForCarrierLink(
          linkedExistingShipperId,
        );
        if (!cancelled) setLinkEmbarcadorOptions(list);
      } catch (error) {
        console.error("Erro ao carregar embarcadores para vínculo:", error);
        if (!cancelled) setLinkEmbarcadorOptions([]);
      } finally {
        if (!cancelled) setLoadingLinkEmbarcadores(false);
      }
    };

    loadLinkEmbarcadores();
    return () => {
      cancelled = true;
    };
  }, [linkedExistingShipperId, user?.viewALL]);

  useEffect(() => {
    if (id) {
      firebase
        .firestore()
        .collection("shipper")
        .doc(id)
        .get()
        .then(async (result) => {
          var data = result.data();
          if (id) {
            setSocialName(data.dataPersonal.socialName);
            setDocumentNamber(
              shipperService.formatCnpjMask(data.dataPersonal.documentNumber) ||
              data.dataPersonal.documentNumber ||
              "",
            );
            setNameFantasy(data.dataPersonal.nameFantasy);
            setTaxRegime(data?.dataPersonal?.taxRegime || "");
            setInscricaoEstadual(data.dataPersonal.inscricaoEstadual);
            // suporta contact como object (antigo) ou array (novo)
            if (Array.isArray(data.contact)) {
              setContatos(
                data.contact.length
                  ? data.contact.map((item) => normalizeContato(item))
                  : [createContatos()],
              );
            } else if (data.contact) {
              setPhoneNumberFirst(data.contact.phoneNumberFirst || "");
              setPhoneNumberSecond(data.contact.phoneNumberSecond || "");
            }

            setCep(data.address.cep);
            setStreet(data?.address.street);
            setNeighborhood(data?.address.neighborhood);
            setCity(data?.address.city);
            setState(data?.address.state);
            setNumeroEndereco(data?.address.numeroEndereco);
            setComplement(data?.address.complement);

            setSerie(data.mdfe.serie);
            setNumber(data.mdfe.number);
            setTypeEmitente(data.mdfe.typeEmitente);
            setTypeEmissao(data.mdfe.typeEmissao);
            setResponsavelSeguro(data.mdfe.responsavelSeguro);
            setDocumentCertificate(data.infoCertificate?.certificate);

            setPhotoPreview(data.logo);

            if (Array.isArray(data.groupVisualizer)) {
              setSelectedGroups(data.groupVisualizer.map((g) => g.uid));
            }

            setCreditLimit(
              normalizeCreditLimitValue(data?.financial?.creditLimit),
            );
            // Compatibilidade: le array legado (paymentConditionIds)
            // ou campo unico (paymentConditionId); mantem apenas a primeira.
            const paymentConditionIds = Array.isArray(
              data?.financial?.paymentConditionIds,
            )
              ? data.financial.paymentConditionIds
              : data?.financial?.paymentConditionId
                ? [data.financial.paymentConditionId]
                : [];
            setSelectedPaymentConditionId(
              paymentConditionIds.length > 0 ? paymentConditionIds[0] : "",
            );
            setFinancialObservation(data?.financial?.observation || "");
            setGrissAdvalorem(data?.financial?.grissAdvalorem || "");
            setAdministrationFee(data?.financial?.administrationFee || "");
            setWorkingCapitalFee(data?.financial?.workingCapitalFee || "");
            setOtherExpenses(data?.financial?.otherExpenses || "");
            setSeller(data?.financial?.sellerResponsible || "");
            setPaymentEmailUser(data?.financial?.paymentEmailUser || "");
            setReceivesIcmsBenefits(
              Boolean(data?.financial?.receivesIcmsBenefits),
            );
            setValidateAllSimulations(
              Boolean(data?.financial?.validateAllSimulations),
            );
            setIsTransport(Boolean(data?.isTransport));

            setPasswordCertificate(
              data.infoCertificate?.passwordCertificate
                ? data.infoCertificate?.passwordCertificate
                : "",
            );
            setSerialNumber(
              data.infoCertificate?.serialNumber
                ? data.infoCertificate?.serialNumber
                : "",
            );
            setIssuerName(
              data.infoCertificate?.issuerName
                ? data.infoCertificate?.issuerName
                : "",
            );
            setNotValidBefore(
              data.infoCertificate?.notValidBefore
                ? data.infoCertificate?.notValidBefore
                : "",
            );
            setNotValidAfter(
              data.infoCertificate?.notValidAfter
                ? data.infoCertificate?.notValidAfter
                : "",
            );
            setThumprint(
              data.infoCertificate?.thumbprint
                ? data.infoCertificate?.thumbprint
                : "",
            );
            setSubjectName(
              data.infoCertificate?.subjectName
                ? data.infoCertificate?.subjectName
                : "",
            );
            setCpfCnpj(
              data.infoCertificate?.cpfCnpj
                ? data.infoCertificate?.cpfCnpj
                : "",
            );
            setNameCompany(
              data.infoCertificate?.nameCompany
                ? data.infoCertificate?.nameCompany
                : "",
            );
          }
        })
        .catch((error) => {
          setCarregando(0);
          console.log(error);
        });
    }
  }, [carregando]);

  //Função para consultar CEP
  function buscarCep(input) {
    if (input != null && input.length < 8) {
      return;
    } else {
      fetch("https://viacep.com.br/ws/" + input + "/json/", { mode: "cors" })
        .then((res) => res.json())
        .then((data) => {
          if (data.hasOwnProperty("erro")) {
            setWarningModalTitle("CEP não existente")
            setShowWarningGlobal(true)
          } else {
            setStreet(data?.logradouro);
            setNeighborhood(data?.bairro);
            setCity(data?.localidade);
            setState(data?.uf);
            setNumeroEndereco(data?.numero);
            setComplement(data?.complemento);
          }
        })
        .catch((err) => console.log(err));
    }
  }

  // Consulta o CNPJ na API local da aplicação.
  async function fetchLocalAPI(cnpj) {
    const response = await fetch(`http://localhost:4000/consulta/cnpj/${cnpj}`);
    if (response.status === 400) {
      throw new Error("CNPJ inválido ou mal formatado");
    }
    if (!response.ok) {
      throw new Error(`Erro na requisição local: ${response.status}`);
    }
    const data = await response.json();
    return data;
  }

  // Consulta o CNPJ na API externa open.cnpja.
  async function fetchExternalAPI(cnpj) {
    const response = await fetch(`https://open.cnpja.com/office/${cnpj}`, {
      mode: "cors",
    });
    if (response.status === 400) {
      throw new Error("CNPJ inválido ou mal formatado");
    }
    if (!response.ok) {
      throw new Error(`Erro na requisição externa: ${response.status}`);
    }
    const data = await response.json();
    return data;
  }

  // Consulta o CNPJ na API externa publica.cnpj.ws.
  async function fetchExternalAPI2(cnpj) {
    const response = await fetch(
      `https://publica.cnpj.ws/cnpj/${Number(cnpj)}`,
      { mode: "cors" },
    );
    if (response.status === 400) {
      throw new Error("CNPJ inválido ou mal formatado");
    }
    if (!response.ok) {
      throw new Error(`Erro na requisição externa: ${response.status}`);
    }
    const data = await response.json();
    return data;
  }

  // Preenche os campos do formulário com o retorno da API local.
  function preencherCamposCnpjLocal(data) {
    setSocialName(data?.razao_social || data?.nome_fantasia || "");
    setDocumentNamber(
      shipperService.formatCnpjMask(data?.cnpj) || data?.cnpj || "",
    );
    setNameFantasy(data?.nome_fantasia || data?.razao_social || "");
  }

  // Preenche os campos do formulário com o retorno da open.cnpja.
  function preencherCamposCnpjExternal(data) {
    setSocialName(data?.company?.name || "");
    setDocumentNamber(
      shipperService.formatCnpjMask(data?.taxId) || data?.taxId || "",
    );
    setNameFantasy(data?.alias ? data?.alias : data?.company?.name || "");
  }

  // Preenche os campos do formulário com o retorno da publica.cnpj.ws.
  function preencherCamposCnpjExternal2(data) {
    setSocialName(data?.razao_social || "");
    setDocumentNamber(
      shipperService.formatCnpjMask(data?.estabelecimento?.cnpj) ||
      data?.estabelecimento?.cnpj ||
      "",
    );
    setNameFantasy(
      data?.estabelecimento?.nome_fantasia || data?.razao_social || "",
    );
  }

  function applyExistingTransportadora(shipperData) {
    if (!shipperData?.id) return;

    const personal = shipperData.dataPersonal || {};
    const address = shipperData.address || {};
    const digits = shipperService.normalizeCnpjDigits(personal.documentNumber);
    const documentValue = String(personal.documentNumber || "").includes(".")
      ? personal.documentNumber
      : shipperService.formatCnpjMask(digits) || personal.documentNumber || "";

    linkedFromBaseRef.current = shipperData.id;
    setLinkedExistingShipperId(shipperData.id);
    setClientShipperForCarrierLink(null);
    setIsTransport(true);
    setSocialName(personal.socialName || "");
    setDocumentNamber(documentValue || "");
    setNameFantasy(personal.nameFantasy || personal.socialName || "");
    setTaxRegime(personal.taxRegime || "");
    setInscricaoEstadual(personal.inscricaoEstadual || "");

    if (Array.isArray(shipperData.contact) && shipperData.contact.length) {
      setContatos(shipperData.contact.map((item) => normalizeContato(item)));
    } else if (shipperData.contact) {
      setPhoneNumberFirst(shipperData.contact.phoneNumberFirst || "");
      setPhoneNumberSecond(shipperData.contact.phoneNumberSecond || "");
    }

    setCep(address.cep || "");
    setStreet(address.street || "");
    setNeighborhood(address.neighborhood || "");
    setCity(address.city || "");
    setState(address.state || "");
    setNumeroEndereco(address.numeroEndereco || "");
    setComplement(address.complement || "");
    setPhotoPreview(shipperData.logo || null);
  }

  const formatName = (name) => {
    if (!name) return "";
    return name
      .toLowerCase()
      .split(" ")
      .map((word) => {
        // if (['da', 'de', 'do', 'dos', 'das'].includes(word)) return word;
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(" ");
  };

  // 1) Base Fortio (só transportadora) → 2) APIs externas de CNPJ.
  // Usa sequencial para ignorar respostas atrasadas (evita API sobrescrever a base).
  async function buscarCNPJ(input) {
    const cnpj = shipperService.normalizeCnpjDigits(input);
    if (cnpj.length !== 14) {
      return;
    }

    const requestId = ++cnpjLookupSeqRef.current;
    const isStale = () => requestId !== cnpjLookupSeqRef.current;

    if (!id) {
      try {
        const existingTransportadora =
          await shipperService.getTransportadoraByCNPJ(cnpj);
        if (isStale()) return;
        if (existingTransportadora) {
          applyExistingTransportadora(existingTransportadora);
          return;
        }
      } catch (baseError) {
        console.error("Erro ao consultar transportadora na base:", baseError);
      }
      if (isStale()) return;
      linkedFromBaseRef.current = null;
      setLinkedExistingShipperId(null);
      setClientShipperForCarrierLink(null);
    }

    try {
      const data = await fetchLocalAPI(cnpj);
      if (isStale() || linkedFromBaseRef.current) return;
      preencherCamposCnpjLocal(data);
    } catch (localError) {
      console.log("Erro na API local, tentando API externa:", localError);

      try {
        const data = await fetchExternalAPI(cnpj);
        if (isStale() || linkedFromBaseRef.current) return;
        if (data?.hasOwnProperty("erro")) {
          throw new Error("CNPJ não existente");
        }
        preencherCamposCnpjExternal(data);
      } catch (externalError) {
        console.log("Erro na API Externa 1:", externalError);

        try {
          const data = await fetchExternalAPI2(cnpj);
          if (isStale() || linkedFromBaseRef.current) return;
          if (data?.hasOwnProperty("erro")) {
            throw new Error("CNPJ não existente");
          }
          preencherCamposCnpjExternal2(data);
        } catch (externalError2) {
          if (isStale() || linkedFromBaseRef.current) return;
          console.log("Erro na API Externa 2:", externalError2);
          setWarningModalTitle("CNPJ não existente")
          setShowWarningGlobal(true)
        }
      }
    }
  }

  const renderFieldOption = (props, option) => {
    const { key, ...liProps } = props;

    return (
      <Box component="li" key={key} {...liProps} sx={routeOptionItemSx}>
        <Stack spacing={0.15}>
          <Typography className="route-option-primary" noWrap sx={routeOptionPrimarySx}>
            {option.label}
          </Typography>
          {option.value === "all" ? (
            <Typography noWrap sx={routeOptionSecondarySx}>
              Cálcula todas as quantidades de eixos
            </Typography>
          ) : null}
        </Stack>
      </Box>
    );
  };


  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      setPhoto(file);

      const reader = new FileReader();
      reader.onload = (event) => {
        setPhotoPreview(event.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  async function save() {
    // Transportadora já existente na base: vínculo comercial no embarcador
    // (affiliatedCarrierIds) + affiliate no usuário logado (gestão).
    if (linkedExistingShipperId) {
      setCarregando(1);
      try {
        const authUid = user?.uid || firebase.auth().currentUser?.uid;
        if (!authUid) {
          throw new Error("Usuário autenticado inválido.");
        }

        const isViewAllUser = user?.viewALL === true;
        let embarcadorShipperId = "";

        if (isViewAllUser) {
          embarcadorShipperId = String(
            clientShipperForCarrierLink?.id || "",
          ).trim();
          if (!embarcadorShipperId) {
            setCarregando(0);
            setMsgTipo("erro");
            setTitle("Ops!");
            setMsg(
              "Selecione o embarcador cliente que está vinculando esta transportadora.",
            );
            setOpen(true);
            return;
          }
        } else {
          embarcadorShipperId = String(user?.uidShipper || "").trim();
          if (!embarcadorShipperId) {
            setCarregando(0);
            setMsgTipo("erro");
            setTitle("Ops!");
            setMsg(
              "Seu usuário não possui embarcador vinculado. Não é possível criar o vínculo comercial.",
            );
            setOpen(true);
            return;
          }
        }

        if (embarcadorShipperId === linkedExistingShipperId) {
          setCarregando(0);
          setMsgTipo("erro");
          setTitle("Ops!");
          setMsg(
            "O embarcador cliente não pode ser a mesma transportadora vinculada.",
          );
          setOpen(true);
          return;
        }

        await shipperService.appendAffiliatedCarrier(
          embarcadorShipperId,
          linkedExistingShipperId,
        );

        const nextAffiliates =
          await userService.appendShipperAffiliateForAuthUser(
            authUid,
            linkedExistingShipperId,
          );

        dispatch({
          type: "UPDATE_USER",
          user: {
            ...user,
            uidShipperAffiliates: nextAffiliates,
          },
        });

        setCarregando(0);
        setMsgTipo("sucesso");
        setTitle("Sucesso!");
        setMsg(
          "Transportadora vinculada ao embarcador. Os fretes deste embarcador passam a aparecer habilitados no Lances da transportadora.",
        );
        setOpen(true);
        navigate("/embarcador");
      } catch (error) {
        console.error(error);
        setMsgTipo("erro");
        setCarregando(0);
        setTitle("Ops!");
        setMsg(
          error?.message ||
          "Não foi possível vincular a transportadora. Tente novamente ou contate o suporte.",
        );
        setOpen(true);
      }
      return;
    }

    if (!validateRequiredFields()) return;
    setCarregando(1);

    let photoURL = null;
    if (photo) {
      try {
        const imageBitmap = await createImageBitmap(photo);
        const { width, height } = imageBitmap;

        if (width > 606 || height > 242) {
          alert(
            "A imagem selecionada e grande. Ela sera redimensionada para no maximo 606x242 pixels.",
          );
        }

        const storageRef = ref(storage, `files/logo/${nameFantasy}`);

        await uploadBytesResumable(storageRef, photo);

        photoURL = await getDownloadURL(storageRef);
      } catch (error) {
        console.error("Erro ao salvar:", error);
      }
    }

    var history = {
      created: new Date(),
    };

    var dataPersonal = {
      socialName: socialName,
      documentNumber: documentNumber,
      nameFantasy: nameFantasy,
      taxRegime: taxRegime,
      inscricaoEstadual: inscricaoEstadual,
    };

    const filteredContatos = (contatos || []).filter(
      (contact) =>
        contact.nome ||
        contact.funcao ||
        contact.telefone ||
        contact.email ||
        contact.recebeEmail ||
        contact.receivesFinancial,
    );
    var contactArray = filteredContatos.length ? filteredContatos : [];

    var address = {
      cep: cep,
      street: street,
      neighborhood: neighborhood,
      city: city,
      state: state,
      numeroEndereco: numeroEndereco,
      complement: complement,
    };

    var mdfe = {
      serie: serie,
      number: number,
      typeEmitente: typeEmitente,
      typeEmissao: typeEmissao,
      responsavelSeguro: responsavelSeguro,
    };

    var infoCertificate = {
      certificate: documentCertificate ? documentCertificate : "",
      passwordCertificate: passwordCertificate ? passwordCertificate : "",
      serialNumber: documentCertificateInfo?.serial_number
        ? documentCertificateInfo?.serial_number
        : "",
      issuerName: documentCertificateInfo?.issuer_name
        ? documentCertificateInfo?.issuer_name
        : "",
      notValidBefore: documentCertificateInfo?.not_valid_before
        ? documentCertificateInfo?.not_valid_before
        : "",
      notValidAfter: documentCertificateInfo?.not_valid_after
        ? documentCertificateInfo?.not_valid_after
        : "",
      thumbprint: documentCertificateInfo?.thumbprint
        ? documentCertificateInfo?.thumbprint
        : "",
      subjectName: documentCertificateInfo?.subject_name
        ? documentCertificateInfo?.subject_name
        : "",
      cpfCnpj: documentCertificateInfo?.cpf_cnpj
        ? documentCertificateInfo?.cpf_cnpj
        : "",
      nameCompany: documentCertificateInfo?.nome_razao_social
        ? documentCertificateInfo?.nome_razao_social
        : "",
    };
    const selectedPaymentCondition = paymentConditions.find(
      (condition) => condition.id === selectedPaymentConditionId,
    );
    var financial = {
      creditLimit: creditLimit || creditLimit === 0 ? creditLimit : "",
      paymentConditionIds: selectedPaymentCondition?.id
        ? [selectedPaymentCondition.id]
        : [],
      paymentConditionDescriptions: selectedPaymentCondition?.description
        ? [selectedPaymentCondition.description]
        : [],
      paymentConditionId: selectedPaymentCondition?.id || "",
      paymentConditionDescription:
        selectedPaymentCondition?.description || "",
      observation: financialObservation ? financialObservation : "",
      grissAdvalorem: grissAdvalorem ? grissAdvalorem : "",
      administrationFee: administrationFee ? administrationFee : "",
      workingCapitalFee: workingCapitalFee ? workingCapitalFee : "",
      otherExpenses: otherExpenses ? otherExpenses : "",
      sellerResponsible: seller ? seller : "",
      paymentEmailUser: paymentEmailUser ? paymentEmailUser : "",
      ...(receivesIcmsBenefits ? { receivesIcmsBenefits: true } : {}),
      validateAllSimulations: Boolean(validateAllSimulations),
    };
    const groupVisualizer = (selectedGroups || []).map((uid) => ({ uid }));
    var dataAll = {
      dataPersonal: dataPersonal,
      contact: contactArray,
      address: address,
      history: history,
      logo: photoURL,
      mdfe: mdfe,
      infoCertificate: infoCertificate,
      financial: financial,
      groupVisualizer: groupVisualizer,
      isTransport: Boolean(isTransport),
    };

    try {
      const docRef = await db.collection("shipper").add(dataAll);

      const authUid = user?.uid || firebase.auth().currentUser?.uid;
      if (authUid) {
        try {
          const nextAffiliates =
            await userService.appendShipperAffiliateForAuthUser(
              authUid,
              docRef.id,
            );

          dispatch({
            type: "UPDATE_USER",
            user: {
              ...user,
              uidShipperAffiliates: nextAffiliates,
            },
          });
        } catch (error) {
          console.error(error);
          setMsgTipo("erro");
          setTitle("Ops!");
          setMsg(
            "Embarcador criado, mas não foi possível vinculá-lo ao seu usuário. Entre em contato com o suporte.",
          );
          setOpen(true);
          setCarregando(0);
          return;
        }
      }

      try {
        const users = await userService.getUsers();

        const updatePromises = users
          .filter(
            (listedUser) =>
              listedUser.viewALL === true && listedUser.uid !== authUid,
          )
          .map(async (listedUser) => {
            const updatedAffiliates = Array.isArray(
              listedUser.uidShipperAffiliates,
            )
              ? [...listedUser.uidShipperAffiliates, docRef.id]
              : [docRef.id];

            return userService.updateUser(listedUser.id, {
              uidShipperAffiliates: updatedAffiliates,
            });
          });

        await Promise.all(updatePromises);
      } catch (error) {
        console.error(error);
        setMsgTipo("erro");
        setTitle("Ops!");
        setMsg(
          "Houve um problema interno ao salvar o uid embarcador dentro dos usuarios com viewALL",
        );
        setOpen(true);
      }

      setCarregando(0);
      setSuccessModalTitle("Empresa cadastrada com sucesso!");
      setShowSuccessModal(true);
    } catch (error) {
      setMsgTipo("erro");
      setCarregando(0);
      setTitle("Ops!");
      setMsg("Houve um problema interno ao recuperar os dados do Embarcador");
      setOpen(true);
    }
  }

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseModalClose = () => {
    setShowSuccessModal(false);
    navigate('/embarcador');
  }

  const handleCloseCertificate = () => {
    setOpenCertificate(false);
  };

  async function update() {
    if (!validateRequiredFields()) return;
    setCarregando(1);
    let photoURL = null;
    if (photo) {
      try {
        const imageBitmap = await createImageBitmap(photo);
        const { width, height } = imageBitmap;

        if (width > 606 || height > 242) {
          alert(
            "A imagem selecionada e grande. Ela sera redimensionada para no maximo 606x242 pixels.",
          );
        }

        const storageRef = ref(storage, `files/logo/${nameFantasy}`);

        await uploadBytesResumable(storageRef, photo);

        photoURL = await getDownloadURL(storageRef);
      } catch (error) {
        console.error("Erro ao salvar:", error);
      }
    }

    var history = {
      created: new Date(),
    };

    var dataPersonal = {
      socialName: socialName,
      documentNumber: documentNumber,
      nameFantasy: nameFantasy,
      taxRegime: taxRegime,
      inscricaoEstadual: inscricaoEstadual ? inscricaoEstadual : "",
    };

    const filteredContatos = (contatos || []).filter(
      (contact) =>
        contact.nome ||
        contact.funcao ||
        contact.telefone ||
        contact.email ||
        contact.recebeEmail ||
        contact.receivesFinancial,
    );
    var contact = filteredContatos.length ? filteredContatos : [];

    var address = {
      cep: cep ? cep : "",
      street: street ? street : "",
      neighborhood: neighborhood ? neighborhood : "",
      city: city ? city : "",
      state: state ? state : "",
      numeroEndereco: numeroEndereco ? numeroEndereco : "",
      complement: complement ? complement : "",
    };

    var mdfe = {
      serie: serie ? serie : "",
      number: number ? number : "",
      typeEmitente: typeEmitente ? typeEmitente : "",
      typeEmissao: typeEmissao ? typeEmissao : "Normal",
      responsavelSeguro: responsavelSeguro ? responsavelSeguro : "Próprio",
    };

    if (documentCertificate && Object.keys(documentCertificate).length > 0) {
      var infoCertificate = {
        certificate: documentCertificate || infoCertificate?.certificate || "",
        passwordCertificate:
          passwordCertificate || infoCertificate?.passwordCertificate || "",
        serialNumber:
          documentCertificateInfo?.serial_number || serialNumber || "",
        issuerName: documentCertificateInfo?.issuer_name || issuerName || "",
        notValidBefore:
          documentCertificateInfo?.not_valid_before || notValidBefore || "",
        notValidAfter:
          documentCertificateInfo?.not_valid_after || notValidAfter || "",
        thumbprint: documentCertificateInfo?.thumbprint || thumprint || "",
        subjectName: documentCertificateInfo?.subject_name || subjectName || "",
        cpfCnpj: documentCertificateInfo?.cpf_cnpj || cpfCnpj || "",
        nameCompany:
          documentCertificateInfo?.nome_razao_social || nameCompany || "",
      };
    } else {
      var infoCertificate = {
        certificate: "",
        passwordCertificate: "",
        serialNumber: "",
        issuerName: "",
        notValidBefore: "",
        notValidAfter: "",
        thumbprint: "",
        subjectName: "",
        cpfCnpj: "",
        nameCompany: "",
      };
    }
    const selectedPaymentCondition = paymentConditions.find(
      (condition) => condition.id === selectedPaymentConditionId,
    );
    // Secao financeira persistida junto ao embarcador.
    var financial = {
      creditLimit: creditLimit || creditLimit === 0 ? creditLimit : "",
      paymentConditionIds: selectedPaymentCondition?.id
        ? [selectedPaymentCondition.id]
        : [],
      paymentConditionDescriptions: selectedPaymentCondition?.description
        ? [selectedPaymentCondition.description]
        : [],
      paymentConditionId: selectedPaymentCondition?.id || "",
      paymentConditionDescription:
        selectedPaymentCondition?.description || "",
      observation: financialObservation ? financialObservation : "",
      grissAdvalorem: grissAdvalorem ? grissAdvalorem : "",
      administrationFee: administrationFee ? administrationFee : "",
      workingCapitalFee: workingCapitalFee ? workingCapitalFee : "",
      otherExpenses: otherExpenses ? otherExpenses : "",
      sellerResponsible: seller ? seller : "",
      paymentEmailUser: paymentEmailUser ? paymentEmailUser : "",
      ...(receivesIcmsBenefits ? { receivesIcmsBenefits: true } : {}),
      validateAllSimulations: Boolean(validateAllSimulations),
    };
    const groupVisualizer = (selectedGroups || []).map((uid) => ({ uid }));
    var dataAll = {
      dataPersonal: dataPersonal,
      contact: contact,
      address: address,
      history: history,
      logo: photoURL,
      mdfe: mdfe,
      infoCertificate: infoCertificate,
      financial: financial,
      groupVisualizer: groupVisualizer,
      isTransport: Boolean(isTransport),
    };

    try {
      await db.collection("shipper").doc(id).update(dataAll);
      setCarregando(0);
      setSuccessModalTitle("Empresa atualizada com sucesso!");
      setShowSuccessModal(true);
    } catch (error) {
      setMsgTipo("erro");
      setCarregando(0);
      setTitle("Ops!");
      setMsg("Houve um problema interno ao recuperar os dados do Embarcador");
      setOpen(true);
    }
  }

  const handleCreateSerie = (e) => {
    const value = e.target.value;

    if (value.length <= 3) {
      setSerie(value);

      //cria um sequencial para o campo number
      // const sequencial = parseInt(0, 10) + 1;
      // setNumber(sequencial.toString().padStart(9, '0')); // Preenche com zeros a esquerda ate 9 digitos

      if (!id || number === "") {
        const sequencial = parseInt(0, 10) + 1;
        setNumber(sequencial.toString().padStart(9, "0"));
      }
    }
  };

  const handleDelete = async (downloadUrl) => {
    try {
      // Extrair o caminho do arquivo a partir da URL
      const pathStart = downloadUrl.indexOf("/o/") + 3;
      const pathEnd = downloadUrl.indexOf("?", pathStart);
      const encodedPath = downloadUrl.substring(pathStart, pathEnd);
      const filePath = decodeURIComponent(encodedPath);

      // Referencia ao arquivo no Firebase Storage
      const fileRef = ref(storage, filePath);

      // Deletar o arquivo
      await deleteObject(fileRef);

      console.log("Certificado excluido com sucesso!");
    } catch (error) {
      console.error("Erro ao excluir o arquivo:", error);
      alert("Erro ao excluir o arquivo.");
    }
  };

  const handleClickOpen = () => {
    setOpenCertificate(true);
  };

  const handleUpload = (file, passwordCertificate, certInfo) => {
    if (!file) return;

    if (file && passwordCertificate) {
      if (certInfo) {
        setDocumentCertificateInfo(certInfo);
        setPasswordCertificate(passwordCertificate);
      }
      // return;
    }

    // return;

    var contest = file;

    const storageRef = ref(
      storage,
      `shipper/certificate/${id}/${contest.name}`,
    );

    const uploadTask = uploadBytesResumable(storageRef, contest);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
        );
      },
      (error) => {
        alert(error);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          if (origem === "documentCertificate") {
            setDocumentCertificate(downloadURL);
            setOpenCertificate(false);
            setOrigem("");
          }
        });
      },
    );
  };

  function formatDate(dateString) {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date)) return "";
    return date.toLocaleDateString("pt-BR");
  }

  return (
    <>
      <NewMiniDrawer
        divOpen={
          <div
            className="freight-content align-items-center"
            style={{ paddingTop: "0px" }}
          >
            {origem === "documentCertificate" ? (
              <AlertDialogCertificate
                handleClose={handleCloseCertificate}
                open={openCertificate}
                origem={origem}
                handleUpload={handleUpload}
              />
            ) : (
              <AlertDialog
                handleClose={handleCloseCertificate}
                open={openCertificate}
                origem={origem}
                handleUpload={handleUpload}
              />
            )}

            <div className="form-cadastro">
              <h2>Cadastro de Empresa</h2>

              <div className="form-signin mx-auto mb-4 mb-lg-6">
                <Card
                  sx={{ padding: 2 }}
                  className="form-signin mx-auto mb-4 mb-lg-6 mb-3 mt-4 border border-[10px] border-[#001f3f] rounded-lg p-3 align-items-center"
                  style={{
                    background: "#ffffff",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                    borderRadius: "16px",
                  }}
                >
                  <div
                    className="d-flex align-items-center justify-content-between mb-3"
                    style={{ width: "100%" }}
                  >
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 10 }}
                    >
                      <i
                        className="fa fa-user"
                        style={{ color: "#012443", fontSize: 20 }}
                        aria-hidden="true"
                      ></i>
                      <h4
                        className="mb-0"
                        style={{
                          fontSize: 18,
                          fontWeight: 600,
                          color: "#012443",
                        }}
                      >
                        Dados Principais <span style={{ color: "red" }}>*</span>
                      </h4>
                    </div>
                  </div>

                  <div className="form-signin mx-auto mb-4 mb-lg-6">
                    <div className="row">
                      <div className="col-md-3">
                        <label htmlFor="documentNumber" className="form-label">
                          CNPJ <span style={{ color: "red" }}>*</span>
                        </label>
                        <InputMask
                          disabled={fieldsDisabled && Boolean(id)}
                          mask="99.999.999/9999-99"
                          type="text"
                          onChange={(e) => {
                            const value = e.target.value;
                            const digits =
                              shipperService.normalizeCnpjDigits(value);
                            setDocumentNamber(value);
                            // Só limpa vínculo se o CNPJ digitado mudou de fato.
                            if (
                              linkedFromBaseRef.current &&
                              digits.length !== 14
                            ) {
                              linkedFromBaseRef.current = null;
                              setLinkedExistingShipperId(null);
                              setClientShipperForCarrierLink(null);
                            }
                            buscarCNPJ(value);
                          }}
                          value={documentNumber && documentNumber}
                          className="form-control"
                          id="documentNumber"
                          placeholder="00.000.000/0000-00"
                        />
                      </div>

                      <div className="col-md-4">
                        <label htmlFor="socialName" className="form-label">
                          Razão Social <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          disabled={fieldsDisabled}
                          onChange={(e) => setSocialName(e.target.value)}
                          value={socialName && socialName}
                          className="form-control"
                          id="socialName"
                        />
                      </div>

                      <Stack className="col-md-5">
                        <Typography>Regime Tributário</Typography>
                        <Autocomplete
                          disabled={view}
                          fullWidth
                          renderOption={renderFieldOption}
                          sx={{ ...selectSx }}
                          options={optionsTaxRegime}
                          slotProps={routeAutocompleteSlotProps}
                          value={findSelectOption(optionsTaxRegime, taxRegime)}
                          isOptionEqualToValue={(option, value) =>
                            String(option.value) === String(value.value)
                          }
                          onChange={(_, newValue) =>
                            setTaxRegime(newValue?.value || "")
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Selecione o regime tributário"
                            />
                          )}
                        />
                      </Stack>
                    </div>

                    <div className="row">
                      <div className="col-md-3">
                        <label
                          htmlFor="inscricaoEstadual"
                          className="form-label"
                        >
                          Inscrição Estadual{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          disabled={view}
                          type="text"
                          onChange={(e) => setInscricaoEstadual(e.target.value)}
                          value={inscricaoEstadual && inscricaoEstadual}
                          className="form-control"
                          id="inscricaoEstadual"
                        />
                      </div>

                      <div className="col-md-4">
                        <label htmlFor="nameFantasy" className="form-label">
                          Nome Fantasia <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="text"
                          disabled={fieldsDisabled}
                          onChange={(e) => setNameFantasy(e.target.value)}
                          value={nameFantasy && nameFantasy}
                          className="form-control"
                          id="nameFantasy"
                        />
                      </div>

                      <div className="col-md-5 d-flex align-items-end">
                        <FormControlLabel
                          control={
                            <Checkbox
                              disabled={fieldsDisabled}
                              checked={isTransport}
                              onChange={(event) =>
                                setIsTransport(event.target.checked)
                              }
                            />
                          }
                          label="Transportadora"
                        />
                      </div>
                    </div>

                    {isLinkedExistingTransportadora ? (
                      <Alert severity="info" sx={{ mt: 2 }}>
                        Transportadora encontrada na base. Ao salvar, ela será
                        vinculada comercialmente ao embarcador (sem criar
                        cadastro duplicado) e passará a ver os fretes dele
                        habilitados no Lances.
                      </Alert>
                    ) : null}

                    {isLinkedExistingTransportadora &&
                      user?.viewALL === true ? (
                      <div className="row mt-3">
                        <div className="col-md-8">
                          <label
                            htmlFor="clientShipperForCarrierLink"
                            className="form-label"
                          >
                            Embarcador cliente do vínculo{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <Autocomplete
                            id="clientShipperForCarrierLink"
                            options={linkEmbarcadorOptions}
                            loading={loadingLinkEmbarcadores}
                            value={clientShipperForCarrierLink}
                            getOptionLabel={(option) => {
                              if (!option) return "";
                              const name =
                                option.nameFantasy ||
                                option.socialName ||
                                "";
                              const doc = option.documentNumber
                                ? ` — ${option.documentNumber}`
                                : "";
                              return `${name}${doc}`.trim();
                            }}
                            isOptionEqualToValue={(option, value) =>
                              String(option?.id || "") ===
                              String(value?.id || "")
                            }
                            onChange={(_, value) =>
                              setClientShipperForCarrierLink(value)
                            }
                            noOptionsText="Nenhum embarcador encontrado"
                            sx={{
                              width: "100%",
                              "& .MuiOutlinedInput-root": {
                                borderRadius: "10px",
                              },
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Selecione o embarcador que contrata esta transportadora"
                                size="small"
                              />
                            )}
                          />
                        </div>
                      </div>
                    ) : null}
                  </div>
                </Card>

                <Card
                  sx={{ padding: 2 }}
                  className="form-signin mx-auto mb-4 mb-lg-6 mb-3 mt-4 border border-[10px] border-[#001f3f] rounded-lg p-3"
                  style={{
                    background: "#ffffff",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                    borderRadius: "16px",
                  }}
                >
                  <div
                    className="d-flex align-items-center justify-content-between mb-3"
                    style={{ width: "100%" }}
                  >
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 10 }}
                    >
                      <i
                        className="fa fa-map-marker"
                        style={{ color: "#012443", fontSize: 20 }}
                        aria-hidden="true"
                      ></i>
                      <h4
                        className="mb-0"
                        style={{
                          fontSize: 18,
                          fontWeight: 600,
                          color: "#012443",
                        }}
                      >
                        Endereço <span style={{ color: "red" }}>*</span>
                      </h4>
                    </div>
                    {/* no import / edit buttons as requested */}
                  </div>

                  <div className="form-signin mx-auto mb-4 mb-lg-6">
                    <Grid container spacing={2}>
                      <Grid item xs={12} lg={7}>
                        <div className="row">
                          <div className="col-3">
                            <label htmlFor="cep" className="form-label">
                              CEP <span style={{ color: "red" }}>*</span>
                            </label>
                            <InputMask
                              disabled={view}
                              mask="99999-999"
                              type="text"
                              onChange={(e) => {
                                buscarCep(e.target.value);
                                setCep(e.target.value);
                              }}
                              value={cep && cep}
                              className="form-control"
                              id="cep"
                            />
                          </div>

                          <div className="col-4">
                            <label htmlFor="street" className="form-label">
                              Logradouro <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              disabled={view}
                              type="text"
                              onChange={(e) => setStreet(e.target.value)}
                              value={street && street}
                              className="form-control"
                              id="street"
                            />
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-3">
                            <label htmlFor="numeroEndereco" className="form-label">
                              Número <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              disabled={view}
                              type="text"
                              onChange={(e) => setNumeroEndereco(e.target.value.replace(/\D/g, ""))}
                              value={numeroEndereco && numeroEndereco}
                              className="form-control"
                              id="numeroEndereco"
                            />
                          </div>

                          <div className="col-md-2">
                            <label htmlFor="neighborhood" className="form-label">
                              Bairro <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              disabled={view}
                              type="text"
                              onChange={(e) => setNeighborhood(e.target.value)}
                              value={neighborhood && neighborhood}
                              className="form-control"
                              id="neighborhood"
                            />
                          </div>

                          <div className="col-md-2">
                            <label htmlFor="city" className="form-label">
                              Cidade <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              disabled={view}
                              type="text"
                              onChange={(e) => setCity(e.target.value)}
                              value={city && city}
                              className="form-control"
                              id="neighborhood"
                            />
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-3">
                            <label htmlFor="state" className="form-label">
                              Estado <span style={{ color: "red" }}>*</span>
                            </label>
                            <Select
                              disabled={view}
                              style={{ width: "100%" }}
                              placeholder="Selecione a UF"
                              onChange={(value) => setState(value)}
                              value={state || undefined}
                              options={STATE_UF}
                              showSearch
                              optionFilterProp="label"
                            />
                          </div>

                          <div className="col-md-4">
                            <label htmlFor="complement" className="form-label">
                              Complemento
                            </label>
                            <input
                              disabled={view}
                              type="text"
                              onChange={(e) => setComplement(e.target.value)}
                              value={complement && complement}
                              className="form-control"
                              id="complement"
                            />
                          </div>
                        </div>
                      </Grid>

                      <Grid item xs={12} lg={5}>
                        <Stack spacing={2} sx={{ height: "100%" }}>
                          <Box>
                            <Typography
                              sx={{
                                fontSize: 14,
                                fontWeight: 600,
                                color: "#012443",
                                mb: 1,
                              }}
                            >
                              Usuário Vinculado
                            </Typography>
                            {!id ? (
                              <Typography sx={{ fontSize: 13, color: "#666" }}>
                                Salve o embarcador para visualizar os usuários
                                vinculados.
                              </Typography>
                            ) : loadingShipperUsers ? (
                              <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
                                <CircularProgress size={22} />
                              </Box>
                            ) : (
                              <Box sx={userListScrollSx}>
                                {linkedUsers.length === 0 ? (
                                  <Typography sx={{ fontSize: 13, color: "#666", p: 1 }}>
                                    Nenhum usuário vinculado.
                                  </Typography>
                                ) : (
                                  linkedUsers.map((linkedUser) => (
                                    <Box key={linkedUser.id} sx={userListItemSx}>
                                      <Box sx={{ minWidth: 0 }}>
                                        <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
                                          {linkedUser.name}
                                        </Typography>
                                        {linkedUser.email ? (
                                          <Typography sx={{ fontSize: 12, color: "#666" }}>
                                            {linkedUser.email}
                                          </Typography>
                                        ) : null}
                                      </Box>
                                    </Box>
                                  ))
                                )}
                              </Box>
                            )}
                          </Box>

                          <Box>
                            <Typography
                              sx={{
                                fontSize: 14,
                                fontWeight: 600,
                                color: "#012443",
                                mb: 1,
                              }}
                            >
                              Usuário com Acesso
                            </Typography>
                            {!id ? (
                              <Typography sx={{ fontSize: 13, color: "#666" }}>
                                Salve o embarcador para gerenciar o acesso de
                                visualização.
                              </Typography>
                            ) : loadingShipperUsers ? (
                              <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
                                <CircularProgress size={22} />
                              </Box>
                            ) : (
                              <Autocomplete
                                multiple
                                disableCloseOnSelect
                                disabled={view || savingAccessUsers}
                                id="access-users-autocomplete-shipper"
                                size="small"
                                sx={{ width: "100%" }}
                                loading={savingAccessUsers}
                                value={accessUserOptions.filter((userItem) =>
                                  selectedAccessUserIds.includes(userItem.id),
                                )}
                                options={accessUserOptions}
                                getOptionLabel={(option) =>
                                  option.email
                                    ? `${option.name} (${option.email})`
                                    : option.name || ""
                                }
                                isOptionEqualToValue={(option, value) =>
                                  option.id === value.id
                                }
                                onChange={handleAccessUsersChange}
                                clearOnBlur
                                noOptionsText="Nenhum usuário encontrado"
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label=""
                                    placeholder="Selecione os usuários com acesso"
                                  />
                                )}
                                renderOption={(props, option) => (
                                  <li {...props} key={option.id}>
                                    {option.name}
                                    {option.email ? ` (${option.email})` : ""}
                                  </li>
                                )}
                                filterOptions={(options, { inputValue }) => {
                                  const normalizedInput = inputValue
                                    .trim()
                                    .toLowerCase();
                                  return options.filter((option) => {
                                    const name = String(option.name || "").toLowerCase();
                                    const email = String(option.email || "").toLowerCase();
                                    return (
                                      name.includes(normalizedInput) ||
                                      email.includes(normalizedInput)
                                    );
                                  });
                                }}
                              />
                            )}
                          </Box>
                        </Stack>
                      </Grid>
                    </Grid>
                  </div>
                </Card>

                <Card
                  sx={{ padding: 2 }}
                  className="form-signin mx-auto mb-4 mb-lg-6 mb-3 mt-4 border border-[10px] border-[#001f3f] rounded-lg p-3"
                  style={{
                    background: "#ffffff",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                    borderRadius: "16px",
                  }}
                >
                  <div className="form-signin mx-auto mb-4 mb-lg-6">
                    <div className="row">
                      <div className="col-12">
                        <h4
                          className="mb-3"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                            fontSize: 18,
                            fontWeight: 600,
                            color: "#012443",
                          }}
                        >
                          <i
                            className="fa fa-address-book"
                            style={{ color: "#012443", fontSize: 20 }}
                            aria-hidden="true"
                          />
                          Contatos
                        </h4>
                      </div>

                      {contatos.map((contato, index) => (
                        <Card
                          sx={{ padding: 2 }}
                          className="form-signin mx-auto mb-4 mb-lg-6 mb-3 mt-4 border border-[10px] border-[#001f3f] rounded-lg p-3"
                          style={{
                            background: "#ffffff",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                            borderRadius: "16px",
                            position: "relative",
                            marginBottom: 16,
                            marginTop: 16,
                          }}
                          key={index}
                        >
                          <Button
                            style={{
                              position: "absolute",
                              top: 8,
                              right: 8,
                              padding: 4,
                              zIndex: 100,
                            }}
                            color="error"
                            onClick={() => removerContato(index)}
                            disabled={contatos.length === 1 || view}
                            title="Remover contato"
                          >
                            <DeleteIcon />
                          </Button>

                          <div key={index}>
                            <div className="row">
                              <div className="col-md-4">
                                <label htmlFor="nome" className="form-label">
                                  Nome
                                </label>
                                <input
                                  disabled={view}
                                  type="text"
                                  onChange={(e) =>
                                    handleChangeMaisContato(
                                      index,
                                      "nome",
                                      e.target.value,
                                    )
                                  }
                                  value={contato.nome}
                                  className="form-control"
                                  id="nome"
                                />
                              </div>
                              <div className="col-md-2">
                                <label htmlFor="funcao" className="form-label">
                                  Função
                                </label>
                                <input
                                  disabled={view}
                                  type="text"
                                  onChange={(e) =>
                                    handleChangeMaisContato(
                                      index,
                                      "funcao",
                                      e.target.value,
                                    )
                                  }
                                  value={contato.funcao}
                                  className="form-control"
                                  id="funcao"
                                />
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-2">
                                <label
                                  htmlFor="telefone"
                                  className="form-label"
                                >
                                  Telefone
                                </label>
                                <InputMask
                                  disabled={view}
                                  mask="(99) 99999-9999"
                                  type="text"
                                  onChange={(e) =>
                                    handleChangeMaisContato(
                                      index,
                                      "telefone",
                                      e.target.value,
                                    )
                                  }
                                  value={contato.telefone}
                                  className="form-control"
                                  id="telefone"
                                />
                              </div>
                              <div className="col-md-2">
                                <label htmlFor="email" className="form-label">
                                  E-mail
                                </label>
                                <input
                                  disabled={view}
                                  type="text"
                                  onChange={(e) =>
                                    handleChangeMaisContato(
                                      index,
                                      "email",
                                      e.target.value,
                                    )
                                  }
                                  value={contato.email}
                                  className="form-control"
                                  id="email"
                                />
                              </div>
                              <div
                                className="col-md-2"
                                style={{ marginTop: 30 }}
                              >
                                <input
                                  disabled={view}
                                  type="checkbox"
                                  onChange={(e) =>
                                    handleChangeMaisContato(
                                      index,
                                      "recebeEmail",
                                      e.target.checked,
                                    )
                                  }
                                  checked={contato.recebeEmail}
                                  className="form-check-input"
                                  id={`recebeEmail-${index}`}
                                  style={{ accentColor: "#043124" }}
                                />
                                Receber E-mail
                              </div>
                              <div
                                className="col-md-2"
                                style={{ marginTop: 30 }}
                              >
                                <input
                                  disabled={view}
                                  type="checkbox"
                                  onChange={(e) =>
                                    handleChangeMaisContato(
                                      index,
                                      "receivesFinancial",
                                      e.target.checked,
                                    )
                                  }
                                  checked={contato.receivesFinancial}
                                  className="form-check-input"
                                  id={`receivesFinancial-${index}`}
                                  style={{ accentColor: "#043124" }}
                                />
                                Recebe Financeiro
                              </div>
                            </div>
                          </div>
                        </Card>
                      ))}

                      <Button
                        sx={{
                          width: "auto",
                          minWidth: 180,
                          marginLeft: 2,
                          alignSelf: "flex-end",
                          fontWeight: 500,
                          color: "#ffffff",
                          backgroundColor: "#012443",
                          textTransform: "none",
                          "&:hover": {
                            backgroundColor: "#012443",
                            boxShadow: "0 6px 18px #012443",
                            transform: "translateY(-2px)",
                            color: "#ffffff",
                          },
                          transition: "all 0.18s ease-in-out",
                        }}
                        disabled={view}
                        type="button"
                        className="btn"
                        onClick={adicionarContato}
                      >
                        + Adicionar Contato
                      </Button>
                    </div>
                  </div>
                </Card>

                {!isTransport && (
                  <Card
                    sx={financialCardSx}
                    className="form-signin mx-auto mb-4 mb-lg-6 mb-3 mt-4 border border-[10px] border-[#001f3f] rounded-lg p-3"
                  >
                    <CardContent sx={financialCardContentSx}>
                      <Stack spacing={0.65} sx={{ mb: 2.5 }}>
                        <Box sx={financialHeaderRowSx}>
                          <i
                            className="fa fa-dollar-sign"
                            style={{ color: "#012443", fontSize: 20 }}
                            aria-hidden="true"
                          />
                          <Typography component="h4" sx={financialTitleSx}>
                            Financeiro
                          </Typography>
                        </Box>
                        <Typography sx={financialSubtitleSx}>
                          Defina limite, condições comerciais e políticas
                          operacionais do embarcador.
                        </Typography>
                      </Stack>

                      <Grid container spacing={2.5}>
                        <Grid item xs={12} md={8}>
                          <Stack spacing={2}>
                            <Box sx={financialSectionSx}>
                              <Typography sx={financialSectionTitleSx}>
                                Condições Comerciais
                              </Typography>

                              <Grid container spacing={2}>
                                <Grid item xs={12} md={4}>
                                  <Typography
                                    component="label"
                                    htmlFor="creditLimit"
                                    sx={financialFieldLabelSx}
                                  >
                                    Limite de Crédito
                                  </Typography>
                                  <IntlCurrencyInput
                                    disabled={view}
                                    currency="BRL"
                                    config={currencyConfig}
                                    onChange={(event, value) =>
                                      setCreditLimit(
                                        normalizeCreditLimitValue(value),
                                      )
                                    }
                                    style={{ height: 40, borderRadius: 10, fontSize: 14 }}
                                    value={creditLimit}
                                    className="form-control"
                                    id="creditLimit"
                                    placeholder="R$ 0,00"
                                    maxLength={15}
                                  />
                                </Grid>

                                <Grid item xs={12} md={8}>
                                  <Typography
                                    component="label"
                                    htmlFor="paymentConditionAutocomplete"
                                    sx={financialFieldLabelSx}
                                  >
                                    Condição de pagamento{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </Typography>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      gap: 1,
                                      alignItems: "flex-start",
                                    }}
                                  >
                                    <Autocomplete
                                      disabled={view}
                                      id="paymentConditionAutocomplete"
                                      size="small"
                                      sx={{ flex: 1 }}
                                      options={paymentConditions.filter(
                                        (condition) =>
                                          condition.active !== false ||
                                          condition.id ===
                                          selectedPaymentConditionId,
                                      )}
                                      value={selectedPaymentCondition}
                                      getOptionLabel={(option) => {
                                        const summary =
                                          getPaymentConditionInstallmentSummary(
                                            option,
                                          );
                                        const base = option.description || "";
                                        if (!summary.count || summary.count <= 1) {
                                          return base;
                                        }
                                        return `${base} (${summary.count} parcelas)`;
                                      }}
                                      isOptionEqualToValue={(option, value) =>
                                        option.id === value.id
                                      }
                                      onChange={(event, newValue) => {
                                        setSelectedPaymentConditionId(
                                          newValue?.id || "",
                                        );
                                      }}
                                      noOptionsText="Nenhuma condicao encontrada"
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label=""
                                          placeholder="Selecione uma condicao de pagamento"
                                          sx={financialTextFieldSx}
                                        />
                                      )}
                                      renderOption={(props, option) => (
                                        <li {...props} key={option.id}>
                                          {option.description || option.id}
                                          {option.observation &&
                                            ` - ${option.observation}`}
                                        </li>
                                      )}
                                    />
                                    {!view && (
                                      <Button
                                        variant="outlined"
                                        onClick={() =>
                                          navigate("/paymentCondition/new")
                                        }
                                        sx={financialActionButtonSx}
                                      >
                                        Criar condição de pagamento
                                      </Button>
                                    )}
                                  </Box>
                                </Grid>

                                {selectedPaymentCondition ? (
                                  <Grid item xs={12} md={4}>
                                    <Typography sx={financialFieldLabelSx}>
                                      Quantidade de Parcelas
                                    </Typography>
                                    <TextField
                                      value={paymentConditionInstallmentSummary.count}
                                      fullWidth
                                      disabled
                                      sx={financialTextFieldSx}
                                    />
                                  </Grid>
                                ) : null}

                                {paymentConditionInstallmentSummary.installments
                                  .length > 0 ? (
                                  <Grid item xs={12}>
                                    <Box
                                      sx={{
                                        border: `1px solid ${theme.colors.primaryBorder}`,
                                        borderRadius: "10px",
                                        overflow: "hidden",
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          display: "grid",
                                          gridTemplateColumns: "120px 1fr 1fr",
                                          gap: 1,
                                          px: 2,
                                          py: 1,
                                          background: theme.colors.primarySoft,
                                          fontWeight: 600,
                                        }}
                                      >
                                        <span>Parcela</span>
                                        <span>Dias para vencimento</span>
                                        <span>Percentual</span>
                                      </Box>
                                      {paymentConditionInstallmentSummary.installments.map(
                                        (installment, index) => (
                                          <Box
                                            key={index}
                                            sx={{
                                              display: "grid",
                                              gridTemplateColumns: "120px 1fr 1fr",
                                              gap: 1,
                                              px: 2,
                                              py: 1,
                                              borderTop: `1px solid ${theme.colors.primaryBorder}`,
                                            }}
                                          >
                                            <span>{`${index + 1}/${paymentConditionInstallmentSummary.count}`}</span>
                                            <span>{installment?.days ?? "—"}</span>
                                            <span>
                                              {installment?.percentage != null
                                                ? `${installment.percentage}%`
                                                : "—"}
                                            </span>
                                          </Box>
                                        ),
                                      )}
                                    </Box>
                                  </Grid>
                                ) : null}

                                <Grid item xs={12}>
                                  <Typography
                                    component="label"
                                    htmlFor="financialObservation"
                                    sx={financialFieldLabelSx}
                                  >
                                    Observações
                                  </Typography>
                                  <TextField
                                    disabled={view}
                                    onChange={(e) =>
                                      setFinancialObservation(e.target.value)
                                    }
                                    value={financialObservation}
                                    id="financialObservation"
                                    multiline
                                    minRows={3}
                                    fullWidth
                                    placeholder="Digite observacoes financeiras"
                                    sx={financialTextFieldSx}
                                  />
                                </Grid>
                              </Grid>
                            </Box>

                            <Box sx={financialSectionSx}>
                              <Typography sx={financialSectionTitleSx}>
                                Encargos Adicionais
                              </Typography>
                              <Grid container spacing={2}>
                                {[
                                  {
                                    id: "grissAdvalorem",
                                    label: "Valor de GRISS/Advalorem",
                                    value: grissAdvalorem,
                                    onChange: (event) =>
                                      setGrissAdvalorem(event.target.value),
                                  },
                                  {
                                    id: "taxaAdministracao",
                                    label: "Taxa de Administração",
                                    value: administrationFee,
                                    onChange: (event) =>
                                      setAdministrationFee(event.target.value),
                                  },
                                  {
                                    id: "taxaCapitalGiro",
                                    label: "Taxa de Capital de Giro",
                                    value: workingCapitalFee,
                                    onChange: (event) =>
                                      setWorkingCapitalFee(event.target.value),
                                  },
                                  {
                                    id: "outrasDespesas",
                                    label: "Outras Despesas",
                                    value: otherExpenses,
                                    onChange: (event) =>
                                      setOtherExpenses(event.target.value),
                                  },
                                ].map((feeField) => (
                                  <Grid item xs={12} sm={6} key={feeField.id}>
                                    <Typography
                                      component="label"
                                      htmlFor={feeField.id}
                                      sx={financialFieldLabelSx}
                                    >
                                      {feeField.label}
                                    </Typography>
                                    <NumericFormat
                                      id={feeField.id}
                                      disabled={view}
                                      value={feeField.value}
                                      onChange={feeField.onChange}
                                      sx={financialTextFieldSx}
                                      fullWidth
                                      size="small"
                                      placeholder="Ex: 3%"
                                      decimalSeparator=","
                                      thousandSeparator="."
                                      decimalScale={2}
                                      fixedDecimalScale={true}
                                      // placeholder="0,00"
                                      customInput={TextField}
                                      InputProps={{
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            {/* <PercentIcon sx={{ color: theme.palette.text.secondary }} /> */}
                                            <PercentIcon fontSize="small" />
                                          </InputAdornment>
                                        ),
                                      }}
                                    />
                                  </Grid>
                                ))}
                              </Grid>
                            </Box>
                          </Stack>
                        </Grid>

                        <Grid item xs={12} md={4}>
                          <Stack spacing={2} sx={financialSectionSx}>
                            <Typography sx={financialSectionTitleSx}>
                              Políticas
                            </Typography>

                            <Box>
                              <Typography
                                component="label"
                                htmlFor="seller-select"
                                sx={financialFieldLabelSx}
                              >
                                Vendedor responsável
                              </Typography>
                              <Autocomplete
                                sx={{ ...financialTextFieldSx }}
                                disabled={view}
                                id="seller-select"
                                size="small"
                                options={sellersList}
                                getOptionLabel={(option) =>
                                  typeof option === "string"
                                    ? option
                                    : option?.label || ""
                                }
                                value={findSelectOption(sellersList, seller)}
                                onChange={(_, newValue) => {
                                  setSeller(newValue?.value || "");
                                }}
                                renderOption={renderFieldOption}
                                noOptionsText="Nenhum vendedor encontrado"
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label=""
                                    placeholder="Selecione o vendedor"
                                    id="seller"
                                    sx={financialTextFieldSx}
                                  />
                                )}
                                isOptionEqualToValue={(option, value) =>
                                  String(option?.value) === String(value?.value)
                                }
                                forcePopupIcon
                              />
                            </Box>

                            <Divider sx={{ borderColor: "rgba(1, 36, 67, 0.12)" }} />

                            <FormControlLabel
                              sx={financialToggleSx}
                              control={
                                <Checkbox
                                  disabled={view}
                                  checked={receivesIcmsBenefits}
                                  onChange={(event) =>
                                    setReceivesIcmsBenefits(event.target.checked)
                                  }
                                />
                              }
                              label="Recebe benefícios de ICMS"
                            />
                            <FormControlLabel
                              sx={financialToggleSx}
                              control={
                                <Checkbox
                                  disabled={view}
                                  checked={validateAllSimulations}
                                  onChange={(event) =>
                                    setValidateAllSimulations(
                                      event.target.checked,
                                    )
                                  }
                                />
                              }
                              label="Valida todas as Simulações"
                            />
                          </Stack>

                          <Stack spacing={2} sx={{ ...financialSectionSx, mt: 2.5 }}>
                            <Box>
                              <Typography
                                component="label"
                                htmlFor="payment-email-select"
                                sx={financialFieldLabelSx}
                              >
                                E-mail pagamento
                              </Typography>
                              <Autocomplete
                                sx={{ ...financialTextFieldSx }}
                                disabled={view}
                                id="payment-email-select"
                                size="small"
                                options={paymentEmailUsersList}
                                getOptionLabel={(option) =>
                                  typeof option === "string"
                                    ? option
                                    : option?.label || ""
                                }
                                value={findSelectOption(
                                  paymentEmailUsersList,
                                  paymentEmailUser,
                                )}
                                onChange={(_, newValue) => {
                                  setPaymentEmailUser(newValue?.value || "");
                                }}
                                renderOption={renderFieldOption}
                                noOptionsText="Nenhum usuário encontrado"
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label=""
                                    placeholder="Selecione o usuário"
                                    id="paymentEmailUser"
                                    sx={financialTextFieldSx}
                                  />
                                )}
                                isOptionEqualToValue={(option, value) =>
                                  String(option?.value) === String(value?.value)
                                }
                                forcePopupIcon
                              />
                            </Box>
                          </Stack>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Card>
                )}

                {!isTransport && (
                  <Card
                    sx={{ padding: 2 }}
                    className="form-signin mx-auto mb-4 mb-lg-6 mb-3 mt-4 border border-[10px] border-[#001f3f] rounded-lg p-3"
                    style={{
                      background: "#ffffff",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                      borderRadius: "16px",
                    }}
                  >
                    <div className="col-12">
                      <h4
                        className="mb-3"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 10,
                          fontSize: 18,
                          fontWeight: 600,
                          color: "#012443",
                        }}
                      >
                        <i
                          className="fa fa-cog"
                          style={{ color: "#012443", fontSize: 20 }}
                          aria-hidden="true"
                        />
                        Parametros MDF-e
                      </h4>
                    </div>

                    <div className="form-signin mx-auto mb-4 mb-lg-4">
                      <div className="row">
                        <div className="col-md-1">
                          <label htmlFor="serie" className="form-label">
                            Série
                          </label>
                          <input
                            type="text"
                            disabled={view}
                            onChange={handleCreateSerie}
                            value={serie && serie}
                            className="form-control"
                            id="documentNumber"
                          />
                        </div>

                        <div className="col-md-3">
                          <label htmlFor="number" className="form-label">
                            Número
                          </label>
                          <input
                            type="text"
                            disabled={view}
                            onChange={(e) => setNumber(e.target.value)}
                            value={number && number}
                            className="form-control"
                            id="socialName"
                          />
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-2">
                          <label htmlFor="typeEmitente" className="form-label">
                            Tipo emitente{" "}
                          </label>
                          <select
                            disabled={view}
                            className="form-select"
                            onChange={(e) => setTypeEmitente(e.target.value)}
                            value={typeEmitente && typeEmitente}
                            aria-label=""
                          >
                            <option defaultValue="">Selecione</option>
                            <option value="1">Prestador de serviço</option>
                            <option value="2">Carga propria </option>
                            <option value="3">Contratante </option>
                          </select>
                        </div>

                        <div className="col-md-2">
                          <label htmlFor="typeEmissao" className="form-label">
                            Tipo emissão
                          </label>
                          <select
                            disabled={view}
                            className="form-select"
                            onChange={(e) => setTypeEmissao(e.target.value)}
                            value={typeEmissao && typeEmissao}
                            aria-label=""
                          >
                            <option defaultValue="">Selecione</option>
                            <option value="1">Normal</option>
                            <option value="2">Contigencia</option>
                          </select>
                        </div>
                        <div className="col-md-2">
                          <label
                            htmlFor="responsavelSeguro"
                            className="form-label"
                          >
                            Responsável pelo seguro
                          </label>
                          <select
                            disabled={view}
                            className="form-select"
                            onChange={(e) => setResponsavelSeguro(e.target.value)}
                            value={responsavelSeguro && responsavelSeguro}
                            aria-label=""
                          >
                            <option defaultValue="">Selecione</option>
                            <option value="Próprio">Próprio</option>
                            <option value="Fracionado">Fortio </option>
                          </select>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-2">
                          <label htmlFor="typeEmitente" className="form-label">
                            Importar certificado{" "}
                          </label>

                          {documentCertificate ? (
                            <ul
                              style={{ listStyle: "none", padding: 0, margin: 0 }}
                            >
                              <li
                                style={{
                                  background: "#f8f9fa",
                                  border: "1px solid #e0e0e0",
                                  borderRadius: "8px",
                                  padding: "2px 3px",
                                  marginBottom: "4px",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                                  transition: "all 0.3s ease",
                                }}
                              >
                                <span style={{ whiteSpace: "nowrap" }}>
                                  Certificado Validado âœ” - Validade:{" "}
                                  {formatDate(
                                    documentCertificateInfo?.not_valid_after,
                                  ) || formatDate(notValidBefore)}{" "}
                                  -{" "}
                                  {documentCertificateInfo?.nome_razao_social ||
                                    subjectName}
                                </span>
                                <IconButton
                                  disabled={view}
                                  aria-label="Excluir"
                                  size="small"
                                  color="error"
                                  onClick={() => {
                                    handleDelete(documentCertificate);
                                    setDocumentCertificate(null);
                                  }}
                                  sx={{
                                    "&:hover": {
                                      backgroundColor: "rgba(211, 47, 47, 0.1)",
                                      transform: "scale(1.1)",
                                    },
                                    transition: "all 0.2s ease-in-out",
                                    padding: "4px",
                                    borderRadius: "50%",
                                    border: "1px solid transparent",
                                    "&:focus": {
                                      outline: "none",
                                      border: "1px solid #d32f2f",
                                    },
                                  }}
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </li>
                            </ul>
                          ) : (
                            <Button
                              disabled={view}
                              variant="contained"
                              onClick={(e) => {
                                handleClickOpen();
                                setOrigem("documentCertificate");
                              }}
                              sx={{
                                backgroundColor: "#012443",
                                color: "#ffffff",
                                textTransform: "none",
                                "&:hover": {
                                  backgroundColor: "#012443",
                                  boxShadow: "0 6px 18px #012443",
                                  transform: "translateY(-2px)",
                                },
                                transition: "all 0.18s ease-in-out",
                              }}
                            >
                              Importar
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>
                  </Card>
                )}

                <Card
                  sx={{ padding: 2 }}
                  className="form-signin mx-auto mb-4 mb-lg-6 mb-3 mt-4 border border-[10px] border-[#001f3f] rounded-lg p-3"
                  style={{
                    background: "#ffffff",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                    borderRadius: "16px",
                  }}
                >
                  <div className="col-12">
                    <h4
                      className="mb-3"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                        fontSize: 18,
                        fontWeight: 600,
                        color: "#012443",
                      }}
                    >
                      <i
                        className="fa fa-users"
                        style={{ color: "#012443", fontSize: 20 }}
                        aria-hidden="true"
                      />
                      Grupos
                    </h4>

                    <div style={{ marginTop: 8 }}>
                      <Autocomplete
                        multiple
                        disableCloseOnSelect
                        disabled={view}
                        id="groups-autocomplete-shipper"
                        size="small"
                        sx={{ width: "35%" }}
                        value={groups.filter((group) =>
                          selectedGroups.includes(group.id),
                        )}
                        getOptionLabel={(option) =>
                          option.name || option.title || ""
                        }
                        options={groups}
                        isOptionEqualToValue={(option, value) =>
                          option.id === value.id
                        }
                        onChange={(event, newValue) => {
                          setSelectedGroups(newValue.map((group) => group.id));
                        }}
                        clearOnBlur
                        noOptionsText="Nenhum grupo encontrado"
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label=""
                            placeholder="Selecione os grupos"
                          />
                        )}
                        renderOption={(props, option) => (
                          <li {...props} key={option.id}>
                            {option.name || option.title || option.id}
                            {option.description && ` - ${option.description}`}
                          </li>
                        )}
                        filterOptions={(options, { inputValue }) => {
                          const normalizedInput = inputValue
                            .trim()
                            .toLowerCase();
                          return options.filter((option) => {
                            const name = String(
                              option.name || option.title || "",
                            ).toLowerCase();
                            const description = String(
                              option.description || "",
                            ).toLowerCase();
                            return (
                              name.includes(normalizedInput) ||
                              description.includes(normalizedInput)
                            );
                          });
                        }}
                      />
                    </div>
                  </div>
                </Card>

                {id && isTransport ? (
                  <Card
                    sx={{ padding: 2 }}
                    className="form-signin mx-auto mb-4 mb-lg-6 mb-3 mt-4 border border-[10px] border-[#001f3f] rounded-lg p-3"
                    style={{
                      background: "#ffffff",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                      borderRadius: "16px",
                    }}
                  >
                    <div className="col-12">
                      <h4
                        className="mb-3"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 10,
                          fontSize: 18,
                          fontWeight: 600,
                          color: "#012443",
                        }}
                      >
                        <i
                          className="fa fa-building"
                          style={{ color: "#012443", fontSize: 20 }}
                          aria-hidden="true"
                        />
                        Embarcadores clientes
                      </h4>
                      <Typography
                        sx={{ mb: 2, color: "#64748b", fontSize: "0.9rem" }}
                      >
                        Embarcadores que têm esta transportadora vinculada
                        (somente leitura).
                      </Typography>

                      {loadingClientEmbarcadores ? (
                        <Typography sx={{ color: "#64748b" }}>
                          Carregando...
                        </Typography>
                      ) : clientEmbarcadores.length === 0 ? (
                        <Typography sx={{ color: "#64748b" }}>
                          Nenhum embarcador vinculado ainda.
                        </Typography>
                      ) : (
                        <Box sx={userListScrollSx}>
                          {clientEmbarcadores.map((item) => (
                            <Box key={item.id} sx={userListItemSx}>
                              <Typography
                                sx={{
                                  fontWeight: 600,
                                  color: "#012443",
                                  fontSize: "0.95rem",
                                }}
                              >
                                {item.nameFantasy ||
                                  item.socialName ||
                                  "Sem nome"}
                              </Typography>
                              <Typography
                                sx={{ color: "#64748b", fontSize: "0.85rem" }}
                              >
                                {item.socialName &&
                                  item.nameFantasy &&
                                  item.socialName !== item.nameFantasy
                                  ? `${item.socialName} · `
                                  : ""}
                                {item.documentNumber || "CNPJ não informado"}
                              </Typography>
                            </Box>
                          ))}
                        </Box>
                      )}
                    </div>
                  </Card>
                ) : null}

                {user?.perfil !== "" ? (
                  <Card
                    sx={{ padding: 2 }}
                    className="form-signin mx-auto mb-4 mb-lg-6 border border-[10px] border-[#001f3f] rounded-lg p-3 align-items-center"
                    style={{
                      background: "#ffffff",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                      borderRadius: "16px",
                    }}
                  >
                    <div className="form-signin mx-auto mb-4 mb-lg-6">
                      <div className="row">
                        <div className="col-12">
                          <h4
                            className="mb-3"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 10,
                              fontSize: 18,
                              fontWeight: 600,
                              color: "#012443",
                            }}
                          >
                            <i
                              className="fa fa-image"
                              style={{ color: "#012443", fontSize: 20 }}
                              aria-hidden="true"
                            />
                            Logo
                          </h4>
                        </div>

                        <div className="col-md-2">
                          {photoPreview ? (
                            <div className="row">
                              <div className="col-md-2">
                                <ImageZoom
                                  title=""
                                  name="photo"
                                  source={photoPreview}
                                  height="100"
                                  width="100"
                                />
                                <Button
                                  disabled={view}
                                  variant="outlined"
                                  onClick={() => setPhotoPreview(null)}
                                  sx={{
                                    color: "#012443",
                                    borderColor: "#012443",
                                    textTransform: "none",
                                    "&:hover": {
                                      backgroundColor: "#043124",
                                      color: "#fff",
                                      borderColor: "#043124",
                                      boxShadow:
                                        "0 6px 18px rgba(4,49,36,0.12)",
                                      transform: "translateY(-2px)",
                                    },
                                    transition: "all 0.18s ease-in-out",
                                  }}
                                  startIcon={
                                    <i
                                      className="fa fa-trash"
                                      style={{ color: "#012443" }}
                                    />
                                  }
                                >
                                  Remover
                                </Button>
                              </div>
                            </div>
                          ) : (
                            <>
                              <input
                                disabled={view}
                                type="file"
                                accept="image/*"
                                onChange={handleFileChange}
                                style={{ display: "none" }}
                                id="upload-image"
                              />
                              <label htmlFor="upload-image">
                                <Button
                                  disabled={view}
                                  variant="contained"
                                  component="span"
                                  onClick={() => { }}
                                  sx={{
                                    backgroundColor: "#012443",
                                    color: "#ffffff",
                                    textTransform: "none",
                                    "&:hover": {
                                      backgroundColor: "#012443",
                                      boxShadow: "0 6px 18px #012443",
                                      transform: "translateY(-2px)",
                                    },
                                    transition: "all 0.18s ease-in-out",
                                  }}
                                  startIcon={
                                    <i
                                      className="fa fa-upload"
                                      style={{ color: "#fff" }}
                                    />
                                  }
                                >
                                  Importar Logo
                                </Button>
                              </label>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </Card>
                ) : null}

                <div className="container">
                  <div className="row">
                    <div className="col-4"></div>
                    <div className="col-4"></div>
                    <div
                      className="col-4"
                      style={{ display: "flex", gap: "10px" }}
                    >
                      <div className="btn-class-cadastrar" style={{ flex: 1 }}>
                        <Link to={"/embarcador"}>
                          <BackButton />
                        </Link>
                      </div>
                      <div className="btn-class-cadastrar" style={{ flex: 1 }}>
                        {carregando ? (
                          <div
                            className="spinner-border text-danger"
                            role="status"
                          >
                            <span className="visually-hidden ">Loading...</span>
                          </div>
                        ) : (
                          <button
                            disabled={view}
                            type="submit"
                            onClick={id ? update : save}
                            className="w-100 btn btn-primary btn-cadastrar"
                          >
                            {isLinkedExistingTransportadora
                              ? "Vincular"
                              : "salvar"}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <Dialog
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogTitle id="alert-dialog-title">
                    <h1>
                      <i
                        class="fa fa-exclamation-triangle"
                        style={{ color: "#FEDE00" }}
                        aria-hidden="true"
                      ></i>
                      {title}
                    </h1>
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      <h6> {msg} </h6>
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <button
                      type="button"
                      onClick={handleClose}
                      className="btn btn-primary btn-cadastrar"
                    >
                      {" "}
                      Ok
                    </button>
                  </DialogActions>
                </Dialog>
                <GlobalSuccessModal
                  open={showSuccessModal}
                  handleClose={handleCloseModalClose}
                  title={successModalTitle}
                />
                <GlobalWarningGlobal
                  open={showWarningGlobal}
                  handleClose={() =>
                    setShowWarningGlobal(false)}
                  title={warningModalTitle}
                />
              </div>
            </div>
          </div>
        }
      />
    </>
  );
}

export default NewEmbarcador;


const selectSx = {


  "& .MuiOutlinedInput-root": {
    borderRadius: `${theme.radius.medium}px`,
    fontSize: 15, // tamanho do texto no input
    height: "40px"
  },
  "& .MuiInputBase-input": {
    fontSize: 15,
  },
};

const financialCardSx = {
  padding: 2,
  background:
    "linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(248,250,252,0.95) 100%)",
  boxShadow: "0 12px 28px rgba(1, 36, 66, 0.12)",
  borderRadius: "16px",
  border: "1px solid rgba(1, 36, 66, 0.12)",
};

const financialCardContentSx = {
  p: { xs: 1, md: 1.5 },
  "&:last-child": {
    pb: { xs: 1, md: 1.5 },
  },
};

const financialHeaderRowSx = {
  display: "flex",
  alignItems: "center",
  gap: 1.25,
};

const financialTitleSx = {
  fontSize: "1.1rem",
  fontWeight: 700,
  color: "#012443",
  letterSpacing: "-0.01em",
  m: 0,
};

const financialSubtitleSx = {
  color: "rgba(1, 36, 67, 0.72)",
  fontSize: "0.9rem",
  fontWeight: 500,
  lineHeight: 1.45,
  maxWidth: 620,
};

const financialSectionSx = {
  border: "1px solid rgba(1, 36, 67, 0.12)",
  borderRadius: "14px",
  p: { xs: 1.2, md: 1.5 },
  backgroundColor: "rgba(255, 255, 255, 0.95)",
};

const financialSectionTitleSx = {
  color: "#012443",
  fontSize: "0.96rem",
  fontWeight: 700,
  letterSpacing: "0.01em",
  textTransform: "uppercase",
  mb: 1.5,
};

const financialFieldLabelSx = {
  display: "block",
  color: "rgba(1, 36, 67, 0.86)",
  fontSize: "0.82rem",
  fontWeight: 600,
  mb: 0.65,
};

const financialTextFieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px",
    fontSize: 14,
  },
  "& .MuiInputBase-input": {
    fontSize: 14,
  },
};

const financialActionButtonSx = {
  minHeight: 40,
  px: `${theme.spacing.sm}px`,
  borderRadius: `${theme.radius.small}px`,
  borderColor: theme.colors.primaryBorder,
  background: theme.colors.primarySoft,
  color: theme.colors.primary,
  whiteSpace: "nowrap",
  textTransform: "none",
  fontSize: theme.typography.bodySize,
  fontWeight: theme.typography.weightSemibold,
  boxShadow: "none",
  transition: theme.motion.transition,
  "&:hover": {
    borderColor: theme.colors.primary,
    background: theme.colors.primary,
    color: theme.colors.white,
    boxShadow: theme.elevation.base,
  },
};

const financialToggleSx = {
  m: 0,
  p: 0.4,
  borderRadius: "10px",
  border: "1px solid rgba(1, 36, 67, 0.12)",
  backgroundColor: "rgba(248, 250, 252, 0.92)",
  "& .MuiFormControlLabel-label": {
    fontSize: "0.86rem",
    color: "#0f172a",
    fontWeight: 500,
  },
};

const routeAutocompleteSlotProps = {
  paper: {
    sx: {
      mt: 1,
      borderRadius: "16px",
      border: "1px solid rgba(1, 36, 66, 0.16)",
      boxShadow: "0 14px 28px rgba(1, 36, 66, 0.18)",
      overflow: "hidden",
    },
  },
  listbox: {
    sx: {
      p: 0.75,
      maxHeight: 360,
      "& .MuiAutocomplete-option": {
        p: 0,
      },
      "&::-webkit-scrollbar": {
        width: 10,
      },
      "&::-webkit-scrollbar-track": {
        background: "rgba(1, 36, 66, 0.08)",
        borderRadius: 999,
      },
      "&::-webkit-scrollbar-thumb": {
        background:
          "linear-gradient(180deg, rgba(1, 36, 66, 0.48) 0%, rgba(1, 36, 66, 0.28) 100%)",
        borderRadius: 999,
        border: "2px solid rgba(1, 36, 66, 0.08)",
      },
    },
  },
};

const routeOptionItemSx = {
  borderRadius: "12px",
  px: 1.25,
  py: 0.9,
  mb: 0.45,
  alignItems: "stretch",
  border: "1px solid transparent",
  transition: "all 120ms ease",
  "&:last-of-type": {
    mb: 0,
  },
  "&:hover": {
    backgroundColor: "rgba(1, 36, 66, 0.06)",
    borderColor: "rgba(1, 36, 66, 0.12)",
  },
  '&[aria-selected="true"]': {
    backgroundColor: "rgba(1, 36, 66, 0.10)",
    borderColor: "rgba(1, 36, 66, 0.26)",
  },
  '&[aria-selected="true"] .route-option-primary': {
    color: "#001f3f",
  },
};

const routeOptionPrimarySx = {
  color: "#0f172a",
  fontSize: "0.92rem",
  fontWeight: 600,
  maxWidth: 330,
  lineHeight: 1.25,
};

const routeOptionSecondarySx = {
  color: "rgba(15, 23, 42, 0.78)",
  fontSize: "0.82rem",
  fontWeight: 500,
  lineHeight: 1.2,
  maxWidth: 440,
};

